import React from "react";
import { motion } from "framer-motion";
import { reveal, container } from "../lib/motion";
import { CHAPTERS } from "../data/site";

export const WhyUs = () => (
  <section className="bg-white py-24 md:py-32">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <motion.div variants={container} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }} className="mb-14 max-w-3xl">
        <motion.span variants={reveal} className="mb-6 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] text-teal">
          <span className="h-px w-10 bg-teal" /> Why Work With Us
        </motion.span>
        <motion.h2 variants={reveal} className="font-display text-4xl font-semibold leading-[0.95] tracking-tighter text-ink md:text-6xl" data-testid="why-headline">
          A Partner, Not Just a Vendor
        </motion.h2>
      </motion.div>

      <motion.div variants={container} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }} className="grid gap-5 md:grid-cols-2 lg:grid-cols-4">
        {CHAPTERS.map((c) => (
          <motion.div
            key={c.n} variants={reveal}
            className="group relative border border-zinc-200 bg-white p-8 transition-transform duration-300 hover:-translate-y-2"
            style={{ boxShadow: "6px 6px 0 rgba(0,0,0,0.03)" }}
            data-testid={`why-card-${c.n}`}
          >
            <span className="font-display text-5xl font-black tracking-tighter text-zinc-100 transition-colors duration-300 group-hover:text-teal/20">{c.n}</span>
            <h3 className="mt-6 font-display text-xl font-semibold leading-tight tracking-tight text-ink">{c.title}</h3>
            <p className="mt-3 font-sans text-sm leading-relaxed text-zinc-500">{c.desc}</p>
            <span className="absolute bottom-0 left-0 h-1 w-0 bg-teal transition-all duration-300 group-hover:w-full" />
          </motion.div>
        ))}
      </motion.div>
    </div>
  </section>
);
